import {
	UsersPageAFY,
} from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { Users } from "@affinitysystemsgroup/github-packages-affinity-components/dist/src/dto/users";
export const UserView = (props: Users) => {
	return <UsersPageAFY {...props} />;
};
